module.exports = __webpack_public_path__ + "179053ed5f533fc03ab2c2fb713a7f6b.png";